module.exports = __webpack_public_path__ + "img/icon-needs-arrow.bc077c76.svg";